import {
  Boxes,
  Building2,
  ClipboardCheck,
  Eye,
  FileMinus,
  Route,
  Users,
} from 'lucide-react';
import { RESULT_TYPES } from '@/data/caseStudies';
import { Reveal } from '../Reveal';

const OUTCOME_ICONS = {
  eye: Eye,
  'file-minus': FileMinus,
  users: Users,
  'clipboard-check': ClipboardCheck,
  route: Route,
  boxes: Boxes,
  'building-2': Building2,
};

export const OutcomeTypes = () => (
  <section aria-labelledby="outcomes-heading" data-testid="outcome-types-section" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center" data-testid="outcomes-header">
        <p className="flex items-center justify-center gap-3">
          <span className="font-mono text-xs font-medium tracking-widest text-gold-700">03</span>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">{RESULT_TYPES.eyebrow}</span>
        </p>
        <h2 id="outcomes-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
          {RESULT_TYPES.heading}
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">{RESULT_TYPES.intro}</p>
      </div>

      <div className="mt-14 flex flex-wrap justify-center gap-5">
        {RESULT_TYPES.items.map((item, i) => {
          const Icon = OUTCOME_ICONS[item.icon];
          return (
            <Reveal key={item.title} delay={(i % 4) * 0.06} className="w-full sm:w-[calc(50%-10px)] lg:w-[calc(25%-15px)]">
              <div
                data-testid={`outcome-${item.icon}`}
                className="flex h-full items-start gap-4 rounded-xl border border-slate-200 bg-white p-6 transition-shadow duration-300 hover:shadow-card"
              >
                <span
                  className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg"
                  style={{ backgroundColor: `${item.color}1A`, color: item.color }}
                >
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="text-base font-extrabold leading-snug tracking-tight text-navy-900">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{item.text}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
